"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.type.target': 'Destinatario',
    'slotData.type.goal': 'Obiettivo',
};
